/**
 * Inservice consent
 * Inservice consent API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@libs/services/auth-strategy';

// @ts-ignore
import { ConsentSignatureDto } from '../model/consentSignatureDto';
// @ts-ignore
import { ConsentSignatureStatusDto } from '../model/consentSignatureStatusDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class ConsentSignaturesManagementService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy, // Inject the strategy if provided
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * @param xTENANTID 
   * @param key Consent document key (e.g. \&quot;virtual-care\&quot;)
   * @param signedById User ID to check signature status for
   * @param signedByType User type (e.g. \&quot;patient\&quot;)
   */
  public async consentSignatureManagementControllerCheckSignatureStatus(xTENANTID: string, key: string, signedById: string, signedByType: string, ): Promise<ConsentSignatureStatusDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling consentSignatureManagementControllerCheckSignatureStatus.');
    }
    if (key === null || key === undefined) {
      throw new Error('Required parameter key was null or undefined when calling consentSignatureManagementControllerCheckSignatureStatus.');
    }
    if (signedById === null || signedById === undefined) {
      throw new Error('Required parameter signedById was null or undefined when calling consentSignatureManagementControllerCheckSignatureStatus.');
    }
    if (signedByType === null || signedByType === undefined) {
      throw new Error('Required parameter signedByType was null or undefined when calling consentSignatureManagementControllerCheckSignatureStatus.');
    }

    let localVarQueryParameters: any = {};
    if (key !== undefined && key !== null) {
      localVarQueryParameters['key'] = key;
    }
    if (signedById !== undefined && signedById !== null) {
      localVarQueryParameters['signedById'] = signedById;
    }
    if (signedByType !== undefined && signedByType !== null) {
      localVarQueryParameters['signedByType'] = signedByType;
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/consent/consent/management/signature/status`,
        params: localVarQueryParameters,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID 
   * @param documentId Filter signatures by document ID
   */
  public async consentSignatureManagementControllerFindAll(xTENANTID: string, documentId?: string, ): Promise<Array<ConsentSignatureDto>> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling consentSignatureManagementControllerFindAll.');
    }

    let localVarQueryParameters: any = {};
    if (documentId !== undefined && documentId !== null) {
      localVarQueryParameters['documentId'] = documentId;
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/consent/consent/management/signature`,
        params: localVarQueryParameters,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
